export default "__VITE_PUBLIC_ASSET__12c16421__"